import React from 'react'
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import { HomeIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Link from 'components/commercetools-ui/atoms/link';
import InfoContent from 'components/commercetools-ui/atoms/info-section-with-image';
import SectionWithBanner from 'components/commercetools-ui/atoms/section-with-banner';
interface ExperienceCenterLocationSpecificProps {
    data: any;
  }
  type componentType = { info_section_with_image: any; section_with_banner: any };
const ExperienceCenterLandingPage: React.FC<ExperienceCenterLocationSpecificProps> = ({data}) => {
  return (
    <div className=" w-full">
      <div className="hidden px-24 pb-8 pt-16 md:block md:px-12 lg:px-32 xl:px-44 2xl:px-64">
        <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
          <Link link={'/'}>
            <HomeIcon className="mt-6 w-20" />
          </Link>
          <span className="text-14 font-normal leading-4 text-[#666]">About Us</span>
          <span className="text-14 font-normal leading-4 text-[#666]">Support</span>
        </Breadcrumb>
      </div>
      <div className="flex flex-col gap-y-48 md:gap-y-50">
        {data?.sections?.map((component: componentType, index: number) => (
          <div key={index}>
             {component?.section_with_banner && (
              <div>
                <SectionWithBanner data={component?.section_with_banner} />
              </div>
            )}
            {component?.info_section_with_image && (
              <div className='xl:px-90 2xl:px-180'>
                <InfoContent data={component?.info_section_with_image} index={index} totalSections={data?.components?.length}/>
              </div>
            )}
           
          </div>
        ))}
      </div>
    </div>
  )
}
export default ExperienceCenterLandingPage